const AccountsTable = () => import(/* webpackChunkName: "accounts-table" */ '@/components/shared/AccountsTable');
const FormSuperAdmin = () => import(/* webpackChunkName: "form-super-admin" */ '../../views/SuperAdmin/FormSuperAdmin');
const FormClinicAdmin = () => import(/* webpackChunkName: "form-clinic-admin" */ '../../views/ClinicAdmin/FormClinicAdmin');
const FormProvider = () => import(/* webpackChunkName: "form-provider" */ '../../views/Provider/FormProvider');
const FormPatient = () => import(/* webpackChunkName: "form-provider" */ '../../views/Patient/FormPatient');

export default [
  {
    path: '/super-admins',
    name: 'SuperAdmins',
    component: AccountsTable,
    meta: {
      title: 'headerTitles["Super Admin"]',
      showToolbarElements: ['createSuperAdmin'],
    },
    props: {
      userRole: 'SUPER_ADMIN',
    },
  },
  {
    path: '/super-admins/create',
    name: 'CreateSuperAdmin',
    component: FormSuperAdmin,
    meta: {
      title: 'headerTitles["Creating Super Admin"]',
    },
  },
  {
    path: '/super-admins/edit/:id',
    name: 'EditSuperAdmin',
    component: FormSuperAdmin,
    meta: {
      title: 'headerTitles["Edit Super Admin"]',
    },
  },
  {
    path: '/clinic-admins',
    name: 'ClinicAdmins',
    component: AccountsTable,
    meta: {
      title: 'headerTitles["Clinic Admin"]',
      showToolbarElements: ['createClinicAdmin'],
    },
    props: {
      userRole: 'CLINIC_ADMIN',
    },
  },
  {
    path: '/clinic-admins/create',
    name: 'CreateClinicAdmin',
    component: FormClinicAdmin,
    meta: {
      title: 'headerTitles["Creating Clinic Admin"]',
    },
  },
  {
    path: '/clinic-admins/edit/:id',
    name: 'EditClinicAdmin',
    component: FormClinicAdmin,
    meta: {
      title: 'headerTitles["Edit Clinic Admin"]',
    },
  },
  {
    path: '/providers',
    name: 'Providers',
    component: AccountsTable,
    meta: {
      title: 'headerTitles.Providers',
      showToolbarElements: ['createProviderBySA', 'createProvider'],
    },
    props: {
      userRole: 'PROVIDER',
    },
  },
  {
    path: '/providers/create',
    name: 'CreateProvider',
    component: FormProvider,
    meta: {
      title: 'headerTitles["Creating Provider"]',
    },
  },
  {
    path: '/providers/edit/:id',
    name: 'EditProvider',
    component: FormProvider,
    meta: {
      title: 'headerTitles["Edit Provider"]',
    },
  },
  {
    path: '/patients',
    name: 'Patients',
    component: AccountsTable,
    meta: {
      title: 'headerTitles.Patients',
      showToolbarElements: ['createPatientBySA', 'createPatient'],
    },
    props: {
      userRole: 'PATIENT',
    },
  },
  {
    path: '/patients/create',
    name: 'CreatePatient',
    component: FormPatient,
    meta: {
      title: 'headerTitles["Creating Patient"]',
    },
  },
  {
    path: '/patients/edit/:id',
    name: 'EditPatient',
    component: FormPatient,
    meta: {
      title: 'headerTitles["Edit Patient"]',
    },
  },
  {
    path: '/gcp',
    name: 'SftpFtpUsers',
    component: () => import('@/views/SFTPUsers/SFTPUsers'),
    meta: {
      title: 'headerTitles.SFTPUsers',
    },
    props: {
      usersRole: 'SUPER_ADMIN',
    },
  },
  {
    path: '/reports/patient',
    name: 'ReportPatient',
    component: () => import('@/views/Reports/ReportPatient'),
    meta: {
      title: 'sidebar.reportPatient',
    },
    props: {
      usersRole: 'SUPER_ADMIN',
    },
  },
];
